import { Component, OnInit } from '@angular/core';
import { NoMatchUserModel } from 'src/app/models/noMatchUser.Model';
import {
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { IngestionService } from 'src/app/services/ingestion.service';
import { DiaryService } from 'src/app/services/diary.service';
import { countryPhoneCode } from 'src/app/models/countryPhoneCodes.model';
import { TableModule } from 'primeng/table';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DatePipe } from '@angular/common';
import { OrderByPipe } from '../../../pipes/orderby.pipe';

@Component({
  selector: 'app-search-no-match-user',
  templateUrl: './search-no-match-user.component.html',
  styleUrls: ['./search-no-match-user.component.sass'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    SelectModule,
    InputTextModule,
    IconFieldModule,
    InputIconModule,
    ProgressSpinnerModule,
    DatePipe,
    OrderByPipe,
  ],
})
export class SearchNoMatchUserComponent implements OnInit {
  isLoadingResults = false;
  rows: NoMatchUserModel[] = [];
  countryCodesSelected: string = '';
  countryCodes: countryPhoneCode[] = [];
  noMatchForm = this.fb.group({
    phoneNumber: [''],
  });

  constructor(
    private diaryService: DiaryService,
    private fb: FormBuilder,
    private ingestionService: IngestionService
  ) {}

  ngOnInit(): void {
    this.diaryService.countryCodes().subscribe({
      next: (x) => {
        this.countryCodes = x;
        this.countryCodesSelected = 'IE';
      },
      error: (e) => {
        this.isLoadingResults = false;
        console.error(e);
      },
    });
  }

  searchByPhoneNumber() {
    let phoneNumber = this.noMatchForm.controls?.phoneNumber.value ?? '';

    if (phoneNumber == '') return;

    this.isLoadingResults = true;
    this.rows = [];

    let countryCode = this.countryCodes.find(
      (x) => x.code == this.countryCodesSelected
    )?.dial_code;

    if (countryCode == '+353') phoneNumber = phoneNumber.replace(/^0+/, '');

    this.ingestionService
      .getNoMatchUserByPhoneNumber(countryCode + phoneNumber)
      .subscribe({
        next: (x) => {
          this.rows = x;
          this.isLoadingResults = false;
        },
        error: (e) => {
          this.isLoadingResults = false;
          console.error(e);
        },
      });
  }
}
